// src/config/deliverables.js
//
// Single source of truth for the kinds of work ("deliverables") we produce for a client.
// Used by the client profitability profile (entering work), the freelancer rate book, and the
// monthly quota tracker. Keep keys stable — they are stored on `deliverables` docs, in a
// client's `monthlyQuotas` map, and in each freelancer's `rates` map.

export const DELIVERABLE_TYPES = [
  { key: 'Reel', en: 'Reel', ar: 'ريل', icon: '🎬' },
  { key: 'Video', en: 'Video', ar: 'فيديو', icon: '📹' },
  { key: 'Photos', en: 'Photos', ar: 'صور', icon: '📷' },
  { key: 'AI', en: 'AI', ar: 'ذكاء اصطناعي', icon: '🤖' },
  { key: 'Design', en: 'Design', ar: 'تصميم', icon: '🎨' },
  { key: 'Motion', en: 'Motion', ar: 'موشن', icon: '✨' },
  { key: 'Printing', en: 'Printing', ar: 'طباعة', icon: '🖨️' },
];

export const DELIVERABLE_KEYS = DELIVERABLE_TYPES.map((t) => t.key);

export const DELIVERABLE_BY_KEY = DELIVERABLE_TYPES.reduce((acc, t) => {
  acc[t.key] = t;
  return acc;
}, {});

// Localized label for a deliverable type key.
export const deliverableLabel = (key, language = 'ar') =>
  DELIVERABLE_BY_KEY[key]?.[language] || DELIVERABLE_BY_KEY[key]?.en || key || '';

export const deliverableIcon = (key) => DELIVERABLE_BY_KEY[key]?.icon || '📦';
